import type { IconNode } from '../types';

/**
 * @name letter-e
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggNEg3YTEgMSAwIDAwLTEgMXYxNGExIDEgMCAwMDEgMWgxMSIgLz4KICA8cGF0aCBkPSJNNiAxMmg4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/letter-e
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterE: IconNode = [
  ['path', { d: 'M18 4H7a1 1 0 00-1 1v14a1 1 0 001 1h11' }],
  ['path', { d: 'M6 12h8' }],
];

export default LetterE;
